import styled from "styled-components";

import { ContainerHalf } from "../VacanciesDetails/Style";

export const ContainerHalfCustom = styled(ContainerHalf)`
  padding: 16px 16px 30px;
`;
